import React from 'react';
import { Badge, ListGroup } from 'react-bootstrap';
import { formatDate } from '../../utils/formatter';

export const ConceptListItem = ({
  concept,
  handleClick,
  disabled,
  selected,
}) => {
  const modified = new Date(concept.lastModified);
  const now = new Date();
  const displayFormat =
    now.getDate() === modified.getDate() &&
    now.getMonth() === modified.getMonth() &&
    now.getFullYear() === modified.getFullYear()
      ? 'time'
      : 'date';

  const onClick = handleClick
    ? (e) => {
        e.preventDefault();
        handleClick(concept);
      }
    : undefined;

  return (
    <ListGroup.Item
      action
      className="d-flex justify-content-between open-concept concept-list-item"
      key={concept.name}
      onClick={onClick}
      disabled={selected | disabled}
    >
      <div>
        <div className="concept-name" style={{ maxWidth: '300px' }}>
          {concept.name}
        </div>
        <div className="text-muted">
          {concept.specificationName} - {formatDate(modified, displayFormat)}
        </div>
      </div>
      <div>{concept.isShared && <Badge bg="primary">Shared</Badge>}</div>
    </ListGroup.Item>
  );
};

export default ConceptListItem;
